const BREADCRUMB_STORAGE_KEY = 'ua-breadcrumbs';

/**
 * Refresh breadcrumb inner HTML from a fetched fragment (e.g. colour-variant product HTML).
 * Call with a response string containing a `.breadcrumbs` node, or dispatch `breadcrumbs:refresh`
 * with `detail.html` containing that markup.
 *
 * @param {string | ParentNode} fetchedHtml — full HTML document string or container element
 */
function refreshBreadcrumbs(fetchedHtml) {
  let source;
  if (typeof fetchedHtml === 'string') {
    source = new DOMParser().parseFromString(fetchedHtml, 'text/html').querySelector('.breadcrumbs');
  } else if (fetchedHtml?.classList?.contains?.('breadcrumbs')) {
    source = fetchedHtml;
  } else {
    source = fetchedHtml?.querySelector?.('.breadcrumbs');
  }
  const destination = document.querySelector('.breadcrumbs');
  if (source && destination) destination.innerHTML = source.innerHTML;
}

window.refreshBreadcrumbs = refreshBreadcrumbs;

document.addEventListener('breadcrumbs:refresh', (event) => {
  const payload =
    event.detail?.html ?? event.detail?.fetchedHtml ?? event.detail?.element ?? event.detail;
  if (!payload) return;
  refreshBreadcrumbs(payload);
});

function cleanCollectionTitle(title) {
  return String(title || '')
    .replace(/[\r\n]+/g, '')
    .replace(/^Collection:\s+/gi, '')
    .trim()
    .replace(/Collection:\s+/gi, '');
}

function collectionTitleFromDom() {
  const h1 =
    document.querySelector('h1.dusk-collection-header__title') ||
    document.querySelector('h1.collection-hero__title') ||
    document.querySelector('.collection-hero h1') ||
    document.querySelector('h1');
  return cleanCollectionTitle(h1?.textContent);
}

function removeStoredBreadcrumb() {
  try {
    localStorage.removeItem(BREADCRUMB_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

function saveCollectionBreadcrumbTrail() {
  const currentURL = window.location.href;
  if (!currentURL.includes('/collections/')) return;

  removeStoredBreadcrumb();

  const pageTitle = collectionTitleFromDom();
  try {
    localStorage.setItem(
      BREADCRUMB_STORAGE_KEY,
      JSON.stringify({
        collection: { title: pageTitle, url: currentURL },
      })
    );
  } catch {
    /* ignore */
  }
}

window.customElements.define(
  'ua-breadcrumbs',
  class UABreadcrumbs extends HTMLElement {
    connectedCallback() {
      whenDocumentReady(() => {
        if (this.dataset.uaBcPdpHydrated !== undefined) return;
        this.dataset.uaBcPdpHydrated = '';
        this.initPostLoad();
      });
      if (!document.body.dataset.uaBreadcrumbDelegate) {
        document.body.dataset.uaBreadcrumbDelegate = 'true';

        /** Product links elsewhere (e.g. PDP, nav): clear inferred collection trail */
        document.body.addEventListener(
          'click',
          (event) => {
            const anchor = event.target.closest?.('a[href*="/products/"]');
            if (!anchor) return;
            const fromGrid =
              anchor.closest('.product-grid') || anchor.closest('#product-grid');
            if (fromGrid && window.location.href.includes('/collections/')) return;
            removeStoredBreadcrumb();
          },
          true
        );

        /** Opens from PLP grid: persist collection hub for PDP back-trail injection */
        document.body.addEventListener(
          'click',
          (event) => {
            const anchor = event.target.closest?.(
              '.product-grid a[href*="/products/"], #product-grid a[href*="/products/"]'
            );
            if (!anchor) return;
            if (!window.location.href.includes('/collections/')) return;
            saveCollectionBreadcrumbTrail();
          },
          true
        );
      }
    }

    initPostLoad() {
      const isProductPage = window.location.pathname.includes('/products/');
      if (!isProductPage) return;

      const previousURL = document.referrer || '';
      if (previousURL.includes('/collections/')) {
        this.addCollectionBreadcrumb();
      } else {
        removeStoredBreadcrumb();
      }
    }

    addCollectionBreadcrumb() {
      let breadcrumbs;
      try {
        breadcrumbs = JSON.parse(localStorage.getItem(BREADCRUMB_STORAGE_KEY));
      } catch {
        breadcrumbs = null;
      }
      if (!breadcrumbs?.collection) return;

      const { title, url } = breadcrumbs.collection;
      if (!title || !url) return;

      const ulElement = this.querySelector('ul, ol');
      if (!ulElement) return;

      const previousURL = document.referrer || '';
      if (previousURL.includes('/products/')) return;

      const firstLiElement = ulElement.querySelector('li:first-child');
      const liElement = document.createElement('li');
      const aElement = document.createElement('a');

      liElement.classList.add('breadcrumbs__item');
      aElement.href = url;
      aElement.classList.add('breadcrumbs__link');
      aElement.textContent = title;
      liElement.appendChild(aElement);

      if (firstLiElement) {
        ulElement.insertBefore(liElement, firstLiElement.nextSibling);
      } else {
        ulElement.appendChild(liElement);
      }
    }
  }
);

function whenDocumentReady(run) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
}
